import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import GppGoodIcon from '@mui/icons-material/GppGood';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckIcon from '@mui/icons-material/Check';

const ShieldWithLock = ({ sx }) => (
	<Box
		sx={{
			position: 'relative',
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			...sx
		}}
	>
		<ShieldOutlinedIcon sx={{ fontSize: '1em', color: 'inherit' }} />
		<LockIcon
			sx={{
				fontSize: '0.4em',
				color: 'inherit',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)'
			}}
		/>
	</Box>
);

ShieldWithLock.propTypes = {
	sx: PropTypes.object
};

const CommonIcons = {
	check: CheckIcon,
	success: CheckCircleIcon,
	lock: LockIcon,
	cart: ShoppingCartOutlinedIcon,
	shield: GppGoodIcon,
	shieldWithLock: ShieldWithLock,
	show: VisibilityIcon,
	hide: VisibilityOffIcon
};

export default CommonIcons;
